import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { useStore } from '@mcn-platform/models';
import ProgressLinear from '../../common/progressLinear/ProgressLinear';
const CourseBar = ({ courseName, progress, settings: { showProgress, showProgressTitle, }, }) => {
    const store = useStore();
    return (_jsxs(AppBar, { position: "static", elevation: 0, className: "courseInfoBar", sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            py: { xs: 2 },
        }, children: [_jsx(Grid, { item: true, xs: 12, md: 6, sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    overflow: 'hidden',
                    alignItems: 'center',
                    flexGrow: 1,
                    mx: 2.5,
                }, children: _jsx(Typography, { variant: "subtitle1", className: "courseInfoBarTitle", children: courseName }) }), _jsx(Grid, { item: true, xs: 12, md: 6, sx: {
                    justifyContent: 'flex-end',
                    my: { xs: 2, md: 0 },
                    alignItems: 'center',
                    flexGrow: 1,
                    mx: 2.5,
                }, children: showProgress && !(store.currentPortal?.type === 'public' && store.isAnonymous) && (_jsx(ProgressLinear, { value: progress, showTitle: showProgressTitle })) })] }));
};
CourseBar.defaultProps = {
    settings: {
        showName: true,
        showNameTitle: true,
        showProgress: true,
        showProgressTitle: true,
    },
};
CourseBar.meta = {
    group: 'hidden',
    name: 'Course Header',
    description: 'Component displays the course name and progress',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showName',
            name: 'Show course name',
            type: 'boolean',
            description: 'Show the course name on app bar.',
        },
        {
            key: 'settings.showNameTitle',
            name: 'Show course name title',
            type: 'boolean',
            description: 'Show the course name header on app bar.',
        },
        {
            key: 'settings.showProgress',
            name: 'Show progress',
            type: 'boolean',
            description: 'Show the course progress on app bar.',
        },
        {
            key: 'settings.showProgressTitle',
            name: 'Show progress title',
            type: 'boolean',
            description: 'Show the course progress header on app bar.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'CourseBar',
        props: {
            courseName: '@course.name',
            progress: '@courseProgress',
            settings: {
                showName: true,
                showNameTitle: true,
                showProgress: true,
                showProgressTitle: true,
            },
        },
    },
};
export default CourseBar;
//# sourceMappingURL=CourseBar.js.map